<div class="backoffice">

  <app-sidebar></app-sidebar>


  <main class="conteudo">

    <router-outlet></router-outlet>

  </main>

</div>
